import { html, SYSBaseElement } from "../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../_ovlclient/src"
import { T } from "../../../../_ovlclient/src/textapi"

export class ScreenSYSAudit extends SYSBaseElement {
  async getUI() {
    return html`
      <div class="fd-layout-panel ">
        <div
          class="fd-layout-panel__body fd-has-padding-base fd-has-margin-base"
        >
          <ovl-table
            class="fd-table fd-table--no-horizontal-borders"
            .props=${() => <SYSTableDefIds>"SYSAudit"}
          >
          </ovl-table>
        </div>
      </div>
    `
  }
}
